<template>
  <div id="order" class="animated fadeIn pb4">
    <!-- desktop view -->
    <div>
      <WebshopHeader>
      </WebshopHeader>
      <div class="clearfix" v-if="loading">
        <div class="col-12">
          <div class="loader"></div>
        </div>
      </div>
      <div class="py4 px3" v-else>
        <div class="pt2"></div>
        <h4 v-if="haaId == orderowner" class="darkblue bold">Ordre #{{placeOrderData.ID}} </h4>
        <div class="py3">
          <div class="p0">
            <div style="font-size:15px">
              <div class="p3 more-muted-background" v-if="haaId == orderowner" >
                <table class="mediumgrey-text  mb1" >
                  <tr class="h6">
                    <td class="bold mr2 pb1">Status:</td>
                    <td class="semi-bold pb1 right-align">
                      <em v-if="placeOrderData.STAGE_ID == 'EXECUTING'">Igang</em>
                      <em v-else>Betalt</em>
                    </td>
                  </tr>
                  <tr class="h6">
                    <td class="bold pr2 pb1">Dato:</td>
                    <td class="semi-bold pb1 right-align"><em>{{placeOrderData.DATE_UPDATE}}</em></td>
                  </tr>
                  <tr class="h6">
                    <td class="bold pr2 pb1">Levering:</td>
                    <td class="semi-bold pb1 right-align"><em>{{placeOrderData.PRICE_DELIVERY.slice(0, -2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " " + currency}}</em></td>
                  </tr>
                  <tr class="h6" v-if="discount.toString().replace(/\B(?=(\d{3})+(?!\d))/g) > 0.00" >
                    <td class="bold pr2 pb1">Rabat:</td>
                    <td class="semi-bold pb1 right-align"><em>{{discount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " " + currency}}</em></td>
                  </tr>
                  <tr class="h6">
                    <td class="bold pr2 pb1">Total:</td>
                    <td class="semi-bold pb1 right-align"><em>{{placeOrderData.PRICE.slice(0, -2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " " + currency}}</em></td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="pb2"></div>
            <div class="el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition">
              <!-- <div class="right-align">
                <el-pagination
                  small
                  layout="prev, pager, next"
                  :total="parseInt(lastPage)" @current-change="paginationChanged" :current-page="parseInt(curPage)">
                </el-pagination>
              </div> -->
              <!-- <div class="clearfix" v-if="insideLoading">
                <div class="col-12">
                  <div class="loader"></div>
                </div>
              </div>
              <div v-else> -->
              <div>
                <table class="el-table__body col-12 p0" v-if="haaId == orderowner">
                  <thead class="has-gutter">
                    <tr>
                      <th colspan="1" rowspan="1" class="el-table_1_column_1 is-leaf">Produkt</th>
                      <th colspan="1" rowspan="1" class="el-table_1_column_1 is-leaf">Antal</th>
                      <th colspan="1" rowspan="1" class="el-table_1_column_1 is-leaf">Pris</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="el-table__row" v-for="(invoice,index) in placeOrderData.webshop_invoice_products" :key="index">
                      <td class="el-table_1_column_1">
                        <span>{{invoice.NAME}}</span>
                      </td>
                      <td class="el-table_1_column_1 qty">
                        <span>{{invoice.QUANTITY}}</span>
                      </td>
                      <td class="el-table_1_column_1 price">
                        <span>{{invoice.PRICE.slice(0, -2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' ' + currency}}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-else >
                  <div class=" p4 ">Tak for din ordre. Tryk venligst på knappen tilbage eller <a class="mintgreen" href="#/webshop/orders" > klik på hende </a> for at se din ordre </div>
                </div>      
              </div>
            </div>
          </div>
        </div>
      </div>
      <WebshopFooter v-if="!loading">
      </WebshopFooter>
    </div>
  </div>
</template>

<script>
import WebshopHeader from './header'
import WebshopFooter from './footer'
export default {
  name: '',
  components: {
    WebshopHeader,
    WebshopFooter
  },
  data () {
    return {
      loading: true,
      insideLoading: false,
      salesPerson: '',
      haaId: '',
      placeOrderData: [],
      discount: '',
      currency: 'kr',
      curPage: 1,
      lastPage: 10,
      orderowner: undefined
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    this.displayOrder()
  },
  methods: {
    showBreadCrumb () {
      document.querySelector('.breadCrumb').classList.remove('hide')
    },
    displayOrder () {
      var urlStr = window.location.href
      var url = new URL(urlStr.replace('/#', ''))
      var searchParams = url.searchParams
      var id = searchParams.get('id')
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetOrders/' + this.haaId + '/' + id + '?page=' + this.curPage
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var dataRes = response.data.data.data[0]
            var pagLastPage = response.data.data.last_page + '0'
            this.placeOrderData = dataRes
            var discountValue = 0
            var qty = 0
            var totalDiscount = 0
            for (var i = 0; i < dataRes.webshop_invoice_products.length; i++) {
              discountValue = dataRes.webshop_invoice_products[i].DISCOUNT_PRICE
              qty = dataRes.webshop_invoice_products[i].QUANTITY
              totalDiscount += discountValue * qty
            }
            if (Number.isInteger(parseInt(totalDiscount))) {
              this.discount = parseInt(totalDiscount) + '.00'
            } else {
              this.discount = parseInt(totalDiscount)
            }
            this.lastPage = pagLastPage
            this.showBreadCrumb()
            this.loading = false
            this.orderowner = res.data.data[0].COMPANY_ID
          } else {
            this.showBreadCrumb()
            this.loading = false
            console.log('Error in displayOrder()')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    paginationChanged (val) {
      var pagCurPage = (`${val}`)
      this.curPage = pagCurPage
      this.displayOrder()
      this.insideLoading = true
    }
  }
}
</script>

<style>
  div .el-table td, .el-table th {
    width: 25%;
    padding: 1rem;
  }
</style>


// WEBPACK FOOTER //
// order.vue?50fbd95d